import { AssetManagerRepair } from './../../../asset-manager/asset-manager-repair';
import { AssetManagerInspection } from './../../../asset-manager/asset-manager-inspection';
import { Injectable, OnDestroy } from '@angular/core'
import { MatDialog, MatDialogRef, MatDialogState } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { AssetInfoModel, ROUTES, SESSION_STORAGE, Util } from '@phdsoft/common'
import { TemplateService } from '../../template.service'
import { PhdsoftCommonService } from '@phdsoft/common'
import { AssetManager } from '../../../asset-manager/asset-manager'
import { DigitalTwinService } from 'src/app/digital-twin/digital-twin.service'
import { Subject } from 'rxjs'
import { Store } from '@ngrx/store'
import { takeUntil } from 'rxjs/operators'
import { DocumentsReduxState } from '../../documents/documents-redux/documents-redux.state'
import { CollectionInspectionGauginsPositioningWizardComponent } from 'src/app/automatic-points/collection-inspection-gaugins-positioning-wizard/collection-inspection-gaugins-positioning-wizard.component';
import { DroneImage } from 'src/app/digital-twin/DroneImage/drone-image-processor';
import { AssetService } from 'src/app/shared/services/asset.service'
import { LinesComputerHelper } from 'src/app/platform/business-logic/linesComputerHelper'
import { SensorsWindowComponent } from 'src/app/sensors/sensors-window/sensors-window.component';
import { AssetManagerMultipleSelection } from 'src/app/asset-manager/asset-manager-multiple-selection';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SpreadsheetService } from 'src/app/digital-twin/spreadsheet/spreadsheet.service';
import { AssetManagerFilter } from 'src/app/asset-manager/asset-manager-filter';
import { VisualizationMode } from '../menu.service';
import { AssetManagerElementInsertion } from 'src/app/asset-manager/asset-manager-element-insertion';
import { AssetManagerCriticalArea } from 'src/app/asset-manager/asset-manager-critical-area';
import { AutomaticPlanTypeSelectorComponent, IAutomaticPlanTypeSelectorData } from 'src/app/automatic-points/automatic-plan-type-selector/automatic-plan-type-selector.component';
import { AutomaticPlanAreaWizardComponent } from 'src/app/automatic-points/automatic-plan-area-wizard/automatic-plan-area-wizard.component';
import { ElementResultInfo } from 'projects/phdsoft/common/src/lib/models/element-result-info.model';
import { GaugingElement } from 'src/app/platform/busines-data/SectionElements/InspectionElements/gaugingElement';
import { AnomalyService } from 'src/app/admin/services/anomaly.service';
import { RiskShieldComponent } from 'src/app/automatic-points/risk-shield/risk-shield.component';
import { AssetLoader } from 'src/app/digital-twin/Loader/AssetLoader';
import { ConsequenceMapComponent } from 'src/app/automatic-points/consequence-map/consequence-map.component';
import { RiskAssessmentComponent } from 'src/app/automatic-points/risk-assessment/risk-assessment.component';
import { AssetManagerTools } from 'src/app/asset-manager/asset-manager-tools';
import { AssetManagerBoxMeasureTool } from 'src/app/asset-manager/asset-manager-boxmeaurement-tool';
// Rendered as a sideboard by TemplateComponent now (showChangeInspectionTargetSideboard); was opened as a dialog here.
// import { ChangeInspectionTargetConfigComponent } from '../../change-inspection-target-config/change-inspection-target-config.component';
import { ChangeCompletedIdsConfigComponent } from '../../change-completed-ids-config/change-completed-ids-config.component';
import { ChangeFullIdsConfigComponent } from '../../change-full-ids-config/change-full-ids-config.component';
import { CreateNewSectionConfigComponent } from '../../create-new-section-config/create-new-section-config.component';
import { JoinFlangesConfigComponent } from '../../join-flanges-config/join-flanges-config.component';
import { CrudBasicDomains } from 'projects/phdsoft/common/src/lib/models/crud-basic-domains.model';
import { CrudBasicDomainsService } from 'src/app/admin/services/crud-basic-domains.service';
import { GridCreation } from 'src/app/digital-twin/DroneImage/DronePath/grid-creation';
import { ViewModeInspectionService } from '@app/template/view-mode-tools/view-mode-inspection/view-mode-inspection.service';
import { ViewModeStructureLabelsService } from '@app/template/view-mode-tools/view-mode-structure-labels/view-mode-structure-labels.service';
import { ViewModeElementsService } from '@app/template/view-mode-tools/view-mode-elements/view-mode-elements.service';

@Injectable() // Do NOT provide at root. Does not make sense globally
export class MenuHomeConfig implements OnDestroy {
  // Subject to manage the unsubscription
  destroy$ = new Subject<boolean>()

  documentsList = []

  sensorsWindowRef: MatDialogRef<any>
  measurementInsertionWindowRef: MatDialogRef<any>

  public autoPointModal: boolean = false;
  public manualPointModal: boolean = false;
  public criticalArea: boolean = false;
  public manualProtection: boolean = false;

  constructor(
    private readonly router: Router,
    private phdsoftCommonService: PhdsoftCommonService,
    private assetManager: AssetManager,
    private assetManagerTools: AssetManagerTools,
    private assetManagerFilter: AssetManagerFilter,
    private assetManagerInspection: AssetManagerInspection,
    private assetManagerMultipleSelection: AssetManagerMultipleSelection,
    private assetManagerRepair: AssetManagerRepair,
    private assetManagerElementInsertion: AssetManagerElementInsertion,
    private assetManagerCriticalArea: AssetManagerCriticalArea,
    private assetManagerBoxMeasureTool: AssetManagerBoxMeasureTool,
    private digitalTwinService: DigitalTwinService,
    private dialog: MatDialog,
    private documentsStore: Store<DocumentsReduxState>,
    private templateService: TemplateService,
    private droneImage: DroneImage,
    private assetService: AssetService,
    private linesComputerHelper: LinesComputerHelper,
    private snackBar: MatSnackBar,
    private serviceCrud: CrudBasicDomainsService,
    private spreadSheetService: SpreadsheetService,
    private assetLoader: AssetLoader,
    private viewModeInspectionService: ViewModeInspectionService,
    private viewModeStructureLabelsService: ViewModeStructureLabelsService,
    private viewModeElementsService: ViewModeElementsService,
  ) {
    this.documentsStore
      .select((state) => {
        this.documentsList = state.documents
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe()
  }

  ngOnDestroy(): void {
    sessionStorage.setItem(SESSION_STORAGE.DOCUMENTS_ACTIVE, '0')

    // Emit a value to complete all observables
    this.destroy$.next(null)
    this.destroy$.complete()
    console.log('💣 Destroy master menu')
  }

  navigate2Map() {
    this.phdsoftCommonService.stopPromises()

    this.templateService.toggleNavigationTools(false);
    this.templateService.toggleVisualizationMode(false);
    this.templateService.toggleComponentList(false);

    console.log(`🗺 Go to Map`)
    window.location.assign(ROUTES.DIGITALTWIN_GEO)
    // if (navigator.onLine) {
    //   console.log(`🗺 Go to Map`)
    //   document.location.assign(ROUTES.DIGITALTWIN_GEO)
    //   // this.router.navigate([ROUTES.DIGITALTWIN_GEO])
    // } else {
    //   this.router
    //     .navigate([ROUTES.DIGITALTWIN_GEO])
    //     .catch(() => this.router.navigate([ROUTES.DIGITALTWIN_GEO]))

    // }
  }

  async navigate2LinkedAsset(assetId) {
    this.phdsoftCommonService.stopPromises()

    let currentAsset = await this.assetService.getCurrentAsset();
    const assetInfoModel: AssetInfoModel = (await this.assetService.getFromMicroservice(assetId)).AssetInfo;

    let anyRegionSelected = false;
    currentAsset.AssetInfo.Regions.forEach((region) => {
      if (region.selected) {
        var r = assetInfoModel.Regions.find(r => r.id == region.id || r.name == region.name); // TODO: after implementing the feature of linking assets and regions, maybe change this
        if (!Util.isNullOrUndefined(r)) {
          r.selected = true
          anyRegionSelected = true;
        }
      }
    });

    if (anyRegionSelected == false) { // Select all
      assetInfoModel.Regions.forEach((region) => {
        region.selected = true
      });
    }

    currentAsset.AssetId = assetId;
    currentAsset.AssetInfo = assetInfoModel;
    await this.assetService.saveCurrentAsset(currentAsset);
    window.location.reload();
  }

  async navigate2Submodel(assetId) {
    this.phdsoftCommonService.stopPromises()

    let currentAsset = await this.assetService.getCurrentAsset();
    const assetInfoModel: AssetInfoModel = (await this.assetService.getFromMicroservice(assetId)).AssetInfo;

    // For submodels, we always select all regions
    assetInfoModel.Regions.forEach((region) => {
      region.selected = true
    });

    currentAsset.AssetId = assetId;
    currentAsset.AssetInfo = assetInfoModel;
    await this.assetService.saveCurrentAsset(currentAsset);
    window.location.reload();
  }

  generateSpreadSheet(formData?: any) {
    // const collectionIdsthis = this.assetManager.asset.InspectionCampaigns.filter(
    //   (x) =>
    //     !x.CollectionInfoModel.IsFinished
    //   //  &&
    //   // x.CollectionInfoModel.CurrentInspectionTypeId === INSPECTIONS_TYPES_IDS.THICKNESS_GAUGING,
    // )
    // const collectionsIds = []
    // const typeNames = []
    // for (const iterator of collectionIdsthis) {
    //   if (!iterator.inspectionTypeId) {
    //     iterator.CollectionInfoModel.InspectionTypeId = INSPECTIONS_TYPES_IDS.THICKNESS_GAUGING;
    //   }
    //   var type = this.assetManager.listInpectionType.find(x => x.id === iterator.inspectionTypeId);
    //   collectionsIds.push(iterator.CollectionInfoModel.CollectionId,);
    //   typeNames.push(type.name);
    // }
    let regions = this.assetManager.asset.GetStructureVisibleRegions();

    let sectionsIds = []
    for (const region of regions) {
      for (const section of region.sections) {
        if(section.visible && !sectionsIds.includes(section.Guid))
          sectionsIds.push(section.Guid);
      }
    }
    if (formData.filterId || formData.planId) {
      this.digitalTwinService.GenerateSpreadSheet(this.assetManager.asset.assetInfo.AssetId, formData.filterId, formData.planId, formData, sectionsIds)
    } else {
      this.templateService.snack.open('Spreadsheet Generation Failed', 'No collection was selected.', { duration: 4000 })
    }
  }

  getNavigationMode() {
    // return this.graphicsNavigatorService.graphics.mode;
    return this.assetManager.asset.mode;
  }

  getNumberOfVisibleRegions() {
    const visibleGroups = this.assetManager.asset.GetVisibleRegions();
    const countVisibleRegions = new Set(visibleGroups.map(item => item.Guid)).size;
    return countVisibleRegions;
    // return this.graphicsNavigatorService.graphics.regionNavigator.filter(r => r.visible).length;
  }

  xRay(type: VisualizationMode) {
    switch (type) {
      case 'Inspection':
        this.assetManager.toggleXRayInspectionViewMode(true);
        break;
      case 'Repair':
        this.assetManager.changeToXRayRepairViewMode();
        break;
      case 'CriticalArea':
        this.assetManager.changeToXRayCriticalAreaViewMode();
        break;

      default:
        break;
    }

  }

  completeIds() {
    this.assetManager.completeIds();
  }
  fullIds() {
    this.assetManager.fullIds();
  }

  flangeElementsView() {
    this.assetManager.flangeElementsView();
  }

  stiffenersBracketsView() {
    this.assetManager.stiffenersBracketsView();
  }

  typicalDetailsFamilyView() {
    this.assetManager.typicalDetailsFamilyView();
  }

  xRaySensor() {
    this.assetManager.changeToXRaySensorViewMode();
  }

  regionsViewMode() {
    this.assetManager.changeToRegionsViewMode();
  }

  materialViewMode() {
    this.assetManager.changeToMaterialsViewMode();
  }

  thicknessColorViewMode() {
    this.assetManager.changeToThicknessTableViewMode();
  }

  structure4DViewMode() {
    this.assetManager.changeToStructure4DViewMode();
  }

  inspectionViewMode(visualizationMode?: string) {
    this.assetManager.changeToInspectionViewMode();
    if (visualizationMode) {
      this.viewModeInspectionService.restoreInspectionViewMode(visualizationMode);
    }
  }

  structuralLabelViewMode(visualizationMode?: string) {
    if (visualizationMode) {
      this.viewModeStructureLabelsService.restoreStructureLabelsViewMode(visualizationMode, this.assetManager);
    }
  }

  elementsViewMode(visualizationMode?: string) {
    if (visualizationMode) {
      this.viewModeElementsService.restoreElementsViewMode(visualizationMode);
    }
  }

  async xRayDegradation() {
    await this.assetManager.changeToDegradationViewMode();
  }

  riskViewMode() {
    this.assetManager.changeToRiskViewMode();
  }

  async remainingLife() {
    await this.assetManager.changeToRemainingLifeViewMode();
  }

  async corrosionRate() {
    await this.assetManager.changeToCorrosionRateViewMode();
  }

  async corrosionRiskIndex() {
    await this.assetManager.changeToCorrosionRiskIndexViewMode();
  }

  transparenceViewMode() {
    this.assetManager.changeToTransparenceViewMode();
  }

  public selectDefaultViewMode() {
    // this.graphicsNavigatorService.graphics.selectDefaultViewMode()
    this.assetManager.changeToDefaultViewMode();
  }

  referenceElementView() {
    this.assetManager.changeToReferenceElementViewMode();
  }

  async droneImageTest(fileList: File[]) {
    await this.droneImage.loadDrone()
    const droneInspectionType: CrudBasicDomains = await this.serviceCrud.getCrudBasicDomainsInspectionList(['7188d6f6-afcd-4fea-a933-fa08f22cb2ae']).toPromise();
    // .subscribe(async (types: CrudBasicDomains) => {

    // },
    //   error => {
    //     console.error('[CollectionInspectionTypeSlct] => loadInspectionType: ', error);
    //   }
    // );

    this.assetManager.listInpectionType = droneInspectionType?.listRows;
    const result = await this.digitalTwinService.droneImageTest(fileList, this.assetManager.asset.assetInfo.id);
    this.assetManager.setCurrentType()
    this.assetManager.functionalityMode = 'INSPECTIONINSERTION'

    //this.assetManager.addInspectionColletion(null, '6a8e3d27-be7c-44a2-b943-a1868e824b1b', '45fc0dce-e0b1-4688-8a55-967e712687fd', 'CVI - Close Visual Inspection')

    await this.droneImage.createDroneInspections(result, fileList)
    this.assetManager.setFunctionalityModeNone();
  }

  loadGltfFile(file: File) {
    this.assetLoader.addGltfFile(this.assetManager.asset, file);
  }

  computeLinesForRegionStiffenersLongitudinals(changeWebToFlange: boolean) {
    this.linesComputerHelper.executeStiffenersLongitudinals(this.assetManager.asset, changeWebToFlange);
  }
  computeLinesForRegionStiffeners(changeWebToFlange: boolean) {
    this.linesComputerHelper.executeStiffeners(this.assetManager.asset, changeWebToFlange);
  }
  computeLinesForRegionBrackets() {
    this.linesComputerHelper.executeBracketsLikeStiffenersNew(this.assetManager.asset, false);
  }
  computeLinesForRegionBracketsFixBrackets() {
    this.linesComputerHelper.executeBracketsFixBrackets(this.assetManager.asset);
  }
  computeLinesForRegionFacePlates() {
    this.linesComputerHelper.executeFacePlates(this.assetManager.asset);
  }

  computeReferenceinesForRegion() {
    this.linesComputerHelper.executeReferenceLines(this.assetManager.asset)
  }

  computeLinesForAllVisibleRegions() {
    this.linesComputerHelper.executeForAllRegions(this.assetManager.asset);
  }

  equalizeColinearLabels() {
    let regions = this.assetManager.asset.GetStructureVisibleRegions();
    let sectionsIds = []
    for (const region of regions) {
      for (const section of region.sections) {
        if (section.visible && !sectionsIds.includes(section.Guid))
          sectionsIds.push(section.Guid);
      }
    }
    this.digitalTwinService.equalizeColinearLabels(this.assetManager.asset.assetInfo.AssetId,
      regions.map(x => x.Guid),
      sectionsIds);
  }

  startInspection() {
    this.manualPointModal = true;
    this.templateService.toggleManualInspectionInsertion(true)
    if (window.navigator.onLine) {
      if (this.assetManager.currentRegion && !this.assetManager.loadCurrentCluster) {
        this.assetManagerFilter.loadCurrentInspectionPlan(this.assetManager.currentRegion.Guid);
      }
    }

    if (
      this.assetManager.functionalityMode !== 'INSPECTIONINSERTION' &&
      (this.assetManager.asset.mode === 'REGIONS' || this.assetManager.asset.mode === 'SECTIONS')
    ) {
      this.assetManagerInspection.startInspectionCollectionMode()
    } else {

      const previousMode = this.assetManager.functionalityMode;
      this.assetManager.setFunctionalityModeNone()
      this.templateService.showElementTypeSelector = false
      this.templateService.showCriticalAreaSelectorComponent = false
      this.templateService.showElementInsertionTypeSelector = false
      if (this.assetManager.asset.mode != 'SECTIONS') {
        this.snackBar.open('Please, double click to enter in a section and start the inspection', '', {
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          duration: 5000
        });
      }

      if (this.assetManager.tempInsertedPointsArray.length > 0 && previousMode == "INSPECTIONINSERTION") {
        this.assetManagerMultipleSelection.toggleMultipleSelection();
        this.assetManagerMultipleSelection.showedSaveAllConfirmation = false;
        this.assetManagerMultipleSelection.selectFirstElement();
        this.assetManagerMultipleSelection.selectSecondaryElements();
      }
    }
  }

  openSensorsWindow() {
    if (
      this.assetManager.functionalityMode !== 'SENSORINSERTION' &&
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      if (this.sensorsWindowRef?.getState() === MatDialogState.OPEN) return

      //this.sensorsWindowRef = this.dialog.open(SensorsWindowComponent, { hasBackdrop: false });
      this.templateService.toggleSensorsWindow(true);
      this.snackBar.open('Select a sensor to continue the operation', '', {
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        duration: 5000
      });



    } else {
      this.assetManager.setFunctionalityModeNone();
      this.snackBar.open('Please, double click to enter in a section and start the inspection.', '', {
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        duration: 5000
      });
    }
  }


  startManualRepair(isSplit: boolean, cut: boolean) {
    if (
      this.assetManager.functionalityMode !== 'MANUALREPAIR' &&
      this.assetManager.functionalityMode !== 'SPLITMANUALREPAIR' &&
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.assetManagerRepair.startRepairCollectionMode(isSplit, cut)
      // Structure Type selection now lives inside the AREA SHAPE sideboard
      this.templateService.showRepairShapeSelectorComponent = true
    } else {

      if( (this.assetManager.functionalityMode === 'SPLITMANUALREPAIR' === isSplit) && this.assetManagerRepair.isCut() === cut)  {
        this.assetManager.setFunctionalityModeNone();
        this.assetManagerRepair.setRepairCutNone();
        this.templateService.showElementTypeSelector = false
      }
      else {
        this.assetManagerRepair.startRepairCollectionMode(isSplit, cut)
        this.templateService.showRepairShapeSelectorComponent = true
      }
    }
  }
  measureTools() {
    if (
      this.assetManager.functionalityMode !== 'MEASURETOOLS' &&
      this.assetManager.functionalityMode !== 'SPLITMANUALREPAIR' &&
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.assetManagerTools.toggleMeasureTools()
      this.templateService.showElementTypeSelector = false
      this.templateService.showCriticalAreaSelectorComponent = false
      this.templateService.showElementInsertionTypeSelector = false
    } else {
      this.assetManager.setFunctionalityModeNone();
      this.assetManagerRepair.setRepairCutNone();
      this.assetManagerTools.clearGeometries();
    }
  }

  startManualProtectionInsertion() {
    this.manualProtection = true
    if (
      this.assetManager.functionalityMode !== 'ELEMENTINSERTION' &&
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      // this.assetManagerElementInsertion.elementType = "protection"
      this.templateService.elementInsertion = !this.templateService.elementInsertion
      this.assetManagerElementInsertion.startElementInsertionSelection("Protection")
      // this.templateService.showElementTypeSelector = true
    } else {
      this.assetManager.setFunctionalityModeNone()
      this.templateService.elementInsertion = false
    }
  }

  startCriticalAreaSelection() {
    if (
      this.assetManager.functionalityMode !== 'CRITICALAREA' &&
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.assetManagerCriticalArea.startCriticalAreaCollectionMode()
      this.templateService.criticalAreaInsertion = !this.templateService.criticalAreaInsertion
      this.templateService.showCriticalAreaSelectorComponent = true
    } else {
      this.assetManager.setFunctionalityModeNone()
      this.templateService.criticalAreaInsertion = false
      this.templateService.showCriticalAreaSelectorComponent = false
    }
  }

  startCriticalAreaByVolume() {
    if (this.assetManager.functionalityMode !== 'CRITICALAREAVOLUME'
      && (this.assetManager.asset.mode === 'SECTIONS' || this.assetManager.asset.mode === 'REGIONS')) {
      this.assetManagerCriticalArea.startCriticalAreaByVolume()
      this.templateService.criticalAreaInsertion = !this.templateService.criticalAreaInsertion
    }

    else {
      this.assetManager.setFunctionalityModeNone()
      this.templateService.criticalAreaInsertion = false
    }
  }

  startWeightMeasurementTool() {
    if (
      this.assetManager.functionalityMode !== 'BOXWEIGHTTOOL' &&
      this.assetManager.asset.mode === 'MODEL' && this.assetManager.asset.isLightModel
    ) {
      this.assetManagerBoxMeasureTool.startWeightMeasurementToolMode()
      this.templateService.boxMeasurementTool = !this.templateService.boxMeasurementTool
    } else {
      this.assetManager.setFunctionalityModeNone()
      this.assetManagerBoxMeasureTool.cancelWeightMeasurementToolMode()
    }
  }

  async endWeightMeasurementTool() {
    if (
      this.assetManager.functionalityMode === 'BOXWEIGHTTOOL' &&
      this.assetManager.asset.mode === 'MODEL' && this.assetManager.asset.isLightModel
    ) {
      this.assetManager.setFunctionalityModeNone()

      this.assetManagerBoxMeasureTool.cancelWeightMeasurementToolMode()
      this.templateService.boxMeasurementTool = !this.templateService.boxMeasurementTool
    } else {
      // this.assetManager.setFunctionalityModeNone()
      // this.assetManagerBoxMeasureTool.clearWeightMeasurementToolMode()
    }
  }

  async inspectionSelectionChange() {
    // QA: new windows go on the sideboard. The floating dialog is kept below for reference.
    // const dialogRef = this.dialog.open(ChangeInspectionTargetConfigComponent, {
    //   panelClass: 'transparentModal',
    //   hasBackdrop: false,
    // });
    if (this.templateService.showChangeInspectionTargetSideboard) {
      // second press closes it, like the other tool sideboards (ngOnDestroy ends the tool)
      this.templateService.showChangeInspectionTargetSideboard = false
    } else if (this.isRegionOpen()) {
      this.templateService.showChangeInspectionTargetSideboard = true
    } else {
      this.snackBarHelper('Open a region first')
    }
  }

  /** The "change inspection target" tool works in SECTIONS and REGIONS. */
  private isRegionOpen(): boolean {
    const mode = this.assetManager.asset?.mode
    return mode === 'SECTIONS' || mode === 'REGIONS'
  }

  async changeCompletedIdsChange() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {

      const dialogRef = this.dialog.open(ChangeCompletedIdsConfigComponent, {
        panelClass: 'transparentModal',
        hasBackdrop: false,
      });
    } else {
      this.assetManager.setFunctionalityModeNone()
    }
  }

  async changeFullIdsChange() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {

      const dialogRef = this.dialog.open(ChangeFullIdsConfigComponent, {
        panelClass: 'transparentModal',
        hasBackdrop: false,
      });
    } else {
      this.assetManager.setFunctionalityModeNone()
    }
  }

  async createNewsection() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {

      const dialogRef = this.dialog.open(CreateNewSectionConfigComponent, {
        panelClass: 'transparentModal',
        hasBackdrop: false,
      });
    } else {
      this.assetManager.setFunctionalityModeNone()
    }
  }

  async joinFlanges() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {

      const dialogRef = this.dialog.open(JoinFlangesConfigComponent, {
        panelClass: 'transparentModal',
        hasBackdrop: false,
      });
    } else {
      this.assetManager.setFunctionalityModeNone()
    }
  }

  // Legacy More-menu entry points (buttons commented out in list-items.component.html),
  // delegating to the retarget controller.
  async inspectionChangeSelectTarget() {
    if (this.isRegionOpen()) {
      this.assetManager.functionalityMode = 'INSPECCHANGETARGET';
    } else {
      this.snackBarHelper('Open a region first')
    }
  }

  async inspectionChangeExecute() {
    if (this.isRegionOpen()) {
      await this.assetManagerInspection.retarget.execute(); // checks the picks, shows its own snackbars
    } else {
      this.snackBarHelper('Open a region first')
    }
  }

  async stopChangeInspecTarget() {
    this.assetManagerInspection.retarget.cancel();
    this.assetManager.setFunctionalityModeNone()
  }

  stopWeightMeasurementTool() {
    if (
      this.assetManager.functionalityMode === 'BOXWEIGHTTOOL' &&
      this.assetManager.asset.mode === 'MODEL' && this.assetManager.asset.isLightModel
    ) {
      this.assetManagerBoxMeasureTool.stopWeightMeasurementToolMode()
    } else {
      // this.assetManager.setFunctionalityModeNone()
      // this.assetManagerBoxMeasureTool.clearWeightMeasurementToolMode()
    }
  }

  automaticPoints() {
    this.templateService.toggleCollectionInspectionGauginsPositioningWizard(false)
    this.templateService.toggleAutomaticPlanAreaWizard(false)
    this.templateService.toggleAutomaticPlanTypeSelector(true)
  }

  riskShield() {
    this.templateService.toggleRiskShield(true)
  }

  riskMatrix() {
    this.templateService.showRiskAssessment = true
  }

  openConsequenceMap() {
    //console.log('Opening consequence map');
    this.templateService.toggleConsequenceMap(true);
  }

  snackBarHelper(message: string) {
    this.snackBar.open(message, '', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration: 7000
    });
  }


  importSpreadSheet(file: File) {
    this.spreadSheetService.ImportSpreadSheet(file)
    .pipe(takeUntil(this.destroy$)).subscribe(
      async (data) => {
        if (!data?.length) {
          console.log('No inspection to update on current asset');
          return;
        }
        this.reloadInspections(data)
        await this.assetManager.reloadAnomalies()
        if (this.assetManager.degradationMode) {
          this.assetManager.estimateDegradationByCurveParameters()
        }
        else {
          this.assetManager.updateAllInspectionColor()
        }
      }
    )
  }

  documentsMode() {
    this.assetManager.changeDocumentsVisibility();
  }

  reloadInspections(inspections: ElementResultInfo[]) {
    let collection = this.assetManager.asset.InspectionCampaigns[0]
    for (let _element of collection.Elements) {
      let index = inspections.findIndex(x => x.id === _element.Guid)
      const gaugingElement = _element as GaugingElement
      if (index !== -1) {
        gaugingElement.checkList = inspections[index].CheckList
        gaugingElement.elementResult = inspections[index]
      }
    }
  }

  buildStiffenerOrthogonal() {
    if (
      this.assetManager.functionalityMode !== 'STIFFNERINSERTION'
    ) {
      this.assetManagerTools.toggleBuildStiffenerOrthogonal()
      // this.templateService.showElementTypeSelector = false
    } else {
      this.assetManager.setFunctionalityModeNone();
      this.assetManagerRepair.setRepairCutNone();
      this.assetManagerTools.clearGeometries();
    }
  }
  CutPlate() {
    if (
      this.assetManager.functionalityMode !== 'CUTPLATE'
    ) {
      this.assetManagerTools.toggleBuildCutPlate()
      // this.templateService.showElementTypeSelector = false
    } else {
      this.assetManager.setFunctionalityModeNone();
      this.assetManagerRepair.setRepairCutNone();
      this.assetManagerTools.clearGeometries();
    }
  }

  mergePlate() {
    if (
      this.assetManager.functionalityMode !== 'MERGEPLATE'
    ) {
      this.assetManagerTools.toggleBuildMergePlate()
      // this.templateService.showElementTypeSelector = false
    } else {
      this.assetManager.setFunctionalityModeNone();
      this.assetManagerRepair.setRepairCutNone();
      this.assetManagerTools.clearGeometries();
    }
  }

  startDroneFlightPlan() {
    if (
      this.assetManager.functionalityMode !== 'DRONEFLIGHTPLAN' &&
      (this.assetManager.asset.mode === 'REGIONS' || this.assetManager.asset.mode === 'MODEL')
    ) {
      this.assetManager.functionalityMode = 'DRONEFLIGHTPLAN';
      this.templateService.droneFlightPlan = !this.templateService.droneFlightPlan;
      // this.templateService.showElementTypeSelector = true;
    } else {
      this.assetManager.setFunctionalityModeNone();
      this.templateService.droneFlightPlan = false;
    }
  }

  startDroneInspectionRoute() {
    if (
      this.assetManager.functionalityMode !== 'DRONEINSPECTIONROUTE' &&
      (this.assetManager.asset.mode === 'REGIONS' || this.assetManager.asset.mode === 'MODEL')
    ) {
      this.assetManager.functionalityMode = 'DRONEINSPECTIONROUTE';
      this.templateService.droneInspectionRoute = true;
    } else {
      this.assetManager.setFunctionalityModeNone();
      this.templateService.droneInspectionRoute = false;
    }
  }
}
